 const data = [
  {
    "id": "japan",
    "color": "hsl(55, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 153
      },
      {
        "x": "helicopter",
        "y": 290
      },
      {
        "x": "boat",
        "y": 99
      },
      {
        "x": "train",
        "y": 87
      },
      {
        "x": "subway",
        "y": 234
      },
      {
        "x": "bus",
        "y": 212
      },
      {
        "x": "car",
        "y": 15
      },
      {
        "x": "moto",
        "y": 284
      },
      {
        "x": "bicycle",
        "y": 151
      },
      {
        "x": "horse",
        "y": 249
      },
      {
        "x": "skateboard",
        "y": 260
      },
      {
        "x": "others",
        "y": 285
      }
    ]
  },
  {
    "id": "france",
    "color": "hsl(26, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 260
      },
      {
        "x": "helicopter",
        "y": 131
      },
      {
        "x": "boat",
        "y": 254
      },
      {
        "x": "train",
        "y": 165
      },
      {
        "x": "subway",
        "y": 76
      },
      {
        "x": "bus",
        "y": 149
      },
      {
        "x": "car",
        "y": 80
      },
      {
        "x": "moto",
        "y": 278
      },
      {
        "x": "bicycle",
        "y": 75
      },
      {
        "x": "horse",
        "y": 136
      },
      {
        "x": "skateboard",
        "y": 0
      },
      {
        "x": "others",
        "y": 265
      }
    ]
  },
  {
    "id": "us",
    "color": "hsl(76, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 192
      },
      {
        "x": "helicopter",
        "y": 119
      },
      {
        "x": "boat",
        "y": 163
      },
      {
        "x": "train",
        "y": 221
      },
      {
        "x": "subway",
        "y": 35
      },
      {
        "x": "bus",
        "y": 186
      },
      {
        "x": "car",
        "y": 130
      },
      {
        "x": "moto",
        "y": 90
      },
      {
        "x": "bicycle",
        "y": 107
      },
      {
        "x": "horse",
        "y": 183
      },
      {
        "x": "skateboard",
        "y": 8
      },
      {
        "x": "others",
        "y": 197
      }
    ]
  },
  {
    "id": "germany",
    "color": "hsl(214, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 3
      },
      {
        "x": "helicopter",
        "y": 7
      },
      {
        "x": "boat",
        "y": 54
      },
      {
        "x": "train",
        "y": 42
      },
      {
        "x": "subway",
        "y": 253
      },
      {
        "x": "bus",
        "y": 293
      },
      {
        "x": "car",
        "y": 217
      },
      {
        "x": "moto",
        "y": 114
      },
      {
        "x": "bicycle",
        "y": 151
      },
      {
        "x": "horse",
        "y": 15
      },
      {
        "x": "skateboard",
        "y": 284
      },
      {
        "x": "others",
        "y": 76
      }
    ]
  },
  {
    "id": "norway",
    "color": "hsl(349, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 44
      },
      {
        "x": "helicopter",
        "y": 285
      },
      {
        "x": "boat",
        "y": 63
      },
      {
        "x": "train",
        "y": 287
      },
      {
        "x": "subway",
        "y": 120
      },
      {
        "x": "bus",
        "y": 118
      },
      {
        "x": "car",
        "y": 108
      },
      {
        "x": "moto",
        "y": 0
      },
      {
        "x": "bicycle",
        "y": 248
      },
      {
        "x": "horse",
        "y": 16
      },
      {
        "x": "skateboard",
        "y": 252
      },
      {
        "x": "others",
        "y": 21
      }
    ]
  }
]
  export default  data